export enum ApiError {
	BLOCKED = "User is blocked",
	INVALID_AUDIO_DATA = "INVALID_AUDIO_DATA",
	GENERIC = "GENERIC",
}
